<template>
  <div class="pl-toolbar-actions" aria-label="Leads actions">
    <div v-if="isSearchActive" class="pl-toolbar-actions__stats" role="list">
      <div class="pl-chip pl-chip--accent" role="listitem">
        <v-icon icon="mdi-magnify" class="pl-chip__icon" size="16" />
        <span class="pl-chip__value">Filtered</span>
      </div>
    </div>

    <div class="pl-toolbar-actions__buttons">
      <v-btn
        variant="flat"
        size="small"
        class="pl-toolbar-btn pl-toolbar-btn--primary"
        prepend-icon="mdi-plus"
        :disabled="!isSessionReady"
        @click="$emit('add')"
      >
        Add Lead
      </v-btn>

      <v-btn
        variant="outlined"
        size="small"
        class="pl-toolbar-btn pl-toolbar-btn--ghost"
        prepend-icon="mdi-file-upload-outline"
        :disabled="!isSessionReady"
        @click="$emit('bulk-upload')"
      >
        Bulk Upload
      </v-btn>

      <v-btn
        variant="outlined"
        size="small"
        class="pl-toolbar-btn pl-toolbar-btn--ghost"
        prepend-icon="mdi-history"
        :disabled="!isSessionReady"
        @click="$emit('upload-history')"
      >
        History
      </v-btn>

      <v-btn
        variant="outlined"
        size="small"
        class="pl-toolbar-btn pl-toolbar-btn--ghost"
        prepend-icon="mdi-refresh"
        :loading="loading"
        :disabled="!isSessionReady"
        @click="$emit('refresh')"
      >
        Refresh
      </v-btn>
    </div>
  </div>
</template>

<script setup>
defineOptions({ name: 'BusinessQueriesHeader' })

defineProps({
  loading: { type: Boolean, default: false },
  isSessionReady: { type: Boolean, default: false },
  isSearchActive: { type: Boolean, default: false },
})

defineEmits(['add', 'bulk-upload', 'upload-history', 'refresh'])
</script>
